import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IsGlobalSpinnerService {

  private _loadingQueue: string[] = [];
  public isLoading = new Subject<boolean>();

  get loadingQueue(): string[] {
    return this._loadingQueue;
  }

  constructor() { }

  public startLoading(id: string = 'loading'): void {
    this._loadingQueue.push(id);
    this.setLoading();
  }

  public stopLoading(id: string = 'loading'): void {
    const i = this._loadingQueue.indexOf(id);
    if (i >= 0) {
      this._loadingQueue.splice(i, 1);
    }
    this.setLoading();
  }

  private setLoading(): void {
    if (this._loadingQueue.length > 0) {
      this.isLoading.next(true);
    } else {
      this.isLoading.next(false);
    }
  }
}
